import Vue from "vue";
import PasswordReset from "./index.vue";
import { mapState } from "vuex";
import { RootState } from "@/store/types";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";
import { removeZendeskLastAuthDate } from "@/helpers/zendesk-helper";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  data() {
    return {
      isLoading: false,
      errors: [],
      ga: {
        error: []
      }
    };
  },
  computed: {
    ...mapState<RootState>({
      partnerUser: (state: RootState) => state.domains.user.partnerUser
    }),
    auth() {
      const reset = this.$store.state.domains.user.passwordReset;
      reset.reset_password_token = this.$route.query.token;
      return reset;
    }
  },
  methods: {
    async handleSubmit() {
      this.isLoading = true;
      this.ga.error.splice(0);
      await this.$store
        .dispatch("domains/user/passwordReset", {
          ...this.auth
        })
        .then(
          () => {
            removeZendeskLastAuthDate();
            this.isLoading = false;
            this.errors = [];

            this.$router
              .push({
                name: "Home",
                query: {
                  isLoggedIn: "true",
                  redirectTo: this.$route.query["redirectTo"]
                }
              })
              .catch(err => err);
          },
          error => {
            if (error.response.data) {
              this.errors = error.response.data.errors;
              this.errors.forEach(error => {
                this.ga.error.push(error.name);
                if (error.name === "invalid_token")
                  this.$router
                    .push({ name: "PasswordError" })
                    .catch(err => err);
              });
            } else {
              // NOTE: response.dataの無いエラー
              this.errors = [
                {
                  name: "unknown",
                  messages: ["エラーが発生しました"]
                }
              ];
              this.ga.error.push(this.errors[0].name);
            }
          }
        );
      this.isLoading = false;
    }
  },
  render(createElement) {
    return createElement(PasswordReset, {
      props: {
        isLoading: this.isLoading,
        errors: this.errors
      },
      on: {
        submit: this.handleSubmit
      }
    });
  }
});
